import { PaymentConfig, PaymentType } from "@/helpers/types/types.ts";

export const getPaymentConfigKey = (config: PaymentConfig): string => {
  if (config.paymentType !== PaymentType.Payment) {
    return config.paymentType;
  }
  return `${config.paymentType}_${config.downPaymentPercentage}`;
};
